/*
 * @Author: yeyimei
 * @Date: 2025-05-28 14:03:33
 * @LastEditTime: 2025-06-04 16:11:26
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\ship.routes.js
 */
export default [
  {
    path: '/cruise-ship/list',
    name: 'cruiseShipList',
    component: () => import('@/views/cruise-ship/list.vue'),
    meta: {
      title: '邮轮列表',
      showName: true,
    },
  },
  {
    path: '/cruise-ship/detail',
    name: 'cruiseShipDetail',
    component: () => import('@/views/cruise-ship/detail.vue'),
    meta: {
      title: '邮轮详情',
      showName: true,
    },
  },
  {
    path: '/ship-member',
    name: 'shipMember',
    component: () => import('@/views/cruise-ship/ship-member.vue'),
    meta: {
      title: '钻石会员',
      showName: true,
    },
  },
  {
    path: '/member-points',
    name: 'memberPoints',
    component: () => import('@/views/mine/member-points.vue'),
    meta: {
      title: '会员绿色积分兑换',
      showName: true,
    },
  },
  {
    path: '/grassland',
    name: 'grassland',
    component: () => import('@/views/cruise-ship/grassland.vue'),
    meta: {
      title: '草原详情',
      showName: true,
    },
  },
]
